export enum StorageTypes {
  block = 'Block',
  file = 'File',
  object = 'Object',
}

export const nbr_VMs = {
  min: 100,
  max: 50000,
  default: 1000,
};

export const XSmallSize = {
  default: (nbr_VMs.default * 5) / 100,
};
export const SmallSize = {
  default: (nbr_VMs.default * 20) / 100,
};
export const MediumSize = {
  default: (nbr_VMs.default * 50) / 100,
};
export const LargeSize = {
  default: (nbr_VMs.default * 20) / 100,
};
export const XLargeSize = {
  default: (nbr_VMs.default * 5) / 100,
};

export const TotalVMs = {
  default: 500,
};

export const Replatform = {
  min: 0,
  max: 100,
  default: 0,
};

export const StorageType = {
  default: StorageTypes.block,
};

export const VmWorkloadDatabase = {
  min: 0,
  max: 100,
  default: 0,
};
export const VmWorkloadAIML = {
  min: 0,
  max: 100,
  default: 0,
};
export const VmWorkloadDataAnalytics = {
  min: 0,
  max: 100,
  default: 0,
};
export const VmWorkloadMessaging = {
  min: 0,
  max: 100,
  default: 0,
};
export const VmWorkloadWebServers = {
  min: 0,
  max: 100,
  default: 0,
};

export const ContainerizeDatabases = {
  min: 0,
  max: 100,
  default: 0,
};
export const ContainerizeAIML = {
  min: 0,
  max: 100,
  default: 0,
};
export const ContainerizeDataAnalytics = {
  min: 0,
  max: 100,
  default: 0,
};
export const ContainerizeMessaging = {
  min: 0,
  max: 100,
  default: 0,
};
export const ContainerizeWebServers = {
  min: 0,
  max: 100,
  default: 0,
};

export const Snapshots = {
  default: false,
};
export const CrashConsistent = {
  default: false,
};
export const ApplicationConsistent = {
  default: false,
};
export const MetroDisaster = {
  default: false,
};
export const RegionalDisaster = {
  default: false,
};

export const MaxServersAdmin = {
  default: 50,
};

export const NbrAdmin = {
  default: 2,
};

export const Salary = {
  default: 112364,
};

export enum FusionHCITypes {
  Total_vCPU = 'Total vCPU (1)',
  Available_vCPU = 'Available vCPU',
  Available_memory = 'Available memory(2) (GB)',
  Usable_NVMe = 'Usable NVMe (3) (TB)',
  NVMe_drives = 'NVMe drives',
  Worker_nodes = 'Worker nodes',
  Control_nodes = 'Control nodes',
  Fusion_Software = 'Fusion Software',
  VPC = 'VPC',
  average_capacity = 'averageCapacity',
}

export enum FusionHCISoftwareTypes {
  VCP = 'VCP',
  License_VCPu = 'License VCPu',
  List_Price = 'List Price (Thousands)',
  Discount = 'Discount',
  Discounted_price = 'Discounted price',
  Average_Cost_per_VCP = 'Average Cost per VCP (Thousands)',
}

export enum FusionHardwareTypes {
  Total_Worker_Nodes = 'Total Worker Nodes',
  Available_vCPU = 'Available vCPU ',
  Available_Memory = 'Available Memory (GB)',
  NVMe_Drives = 'NVMe Drives',
  Available_NVMe = 'Available NVMe (TB)',
  List_Price = 'List Price (Thousands)',
  Discount = 'Discount',
  Total = 'Total',
  Shipping = 'Shipping ',
  Total_in_thousands = 'Total in thousands',
  Total_Nodes = 'Total Nodes',
  Hardware_Cost_per_Node = 'Hardware Cost per Node',
  Premium_Support = 'Premium Support',
}

export interface HCISoftware {
  label: FusionHCITypes | FusionHCISoftwareTypes | FusionHardwareTypes;
  E03: number;
  E05: number;
  E07: number;
  E09: number;
  E11: number;
}

export interface HCI extends HCISoftware {
  E04: number;
  E06: number;
  E08: number;
  E10: number;
}

export interface Size {
  X_small: number;
  Small: number;
  Medium: number;
  Large: number;
  X_large: number;
  Total?: number;
}

export const FusionHCIObject: HCI[] = [
  {
    label: FusionHCITypes.Total_vCPU,
    E03: 96,
    E04: 128,
    E05: 160,
    E06: 192,
    E07: 224,
    E08: 256,
    E09: 288,
    E10: 320,
    E11: 352,
  },
  {
    label: FusionHCITypes.Available_vCPU,
    E03: 60,
    E04: 80,
    E05: 100,
    E06: 120,
    E07: 140,
    E08: 160,
    E09: 180,
    E10: 200,
    E11: 220,
  },
  {
    label: FusionHCITypes.Available_memory,
    E03: 1296,
    E04: 1728,
    E05: 2160,
    E06: 2592,
    E07: 3024,
    E08: 3456,
    E09: 3888,
    E10: 4320,
    E11: 4752,
  },
  {
    label: FusionHCITypes.Available_vCPU,
    E03: 60,
    E04: 80,
    E05: 100,
    E06: 120,
    E07: 140,
    E08: 160,
    E09: 180,
    E10: 200,
    E11: 220,
  },
  {
    label: FusionHCITypes.Usable_NVMe,
    E03: 25,
    E04: 30,
    E05: 35,
    E06: 40,
    E07: 45,
    E08: 50,
    E09: 55,
    E10: 60,
    E11: 65,
  },
  {
    label: FusionHCITypes.NVMe_drives,
    E03: 12,
    E04: 14,
    E05: 16,
    E06: 18,
    E07: 20,
    E08: 22,
    E09: 24,
    E10: 26,
    E11: 28,
  },
  {
    label: FusionHCITypes.Worker_nodes,
    E03: 3,
    E04: 4,
    E05: 5,
    E06: 6,
    E07: 7,
    E08: 8,
    E09: 9,
    E10: 10,
    E11: 11,
  },
  {
    label: FusionHCITypes.Control_nodes,
    E03: 3,
    E04: 3,
    E05: 3,
    E06: 3,
    E07: 3,
    E08: 3,
    E09: 3,
    E10: 3,
    E11: 3,
  },
  {
    label: FusionHCITypes.Fusion_Software,
    E03: 96,
    E04: 128,
    E05: 160,
    E06: 192,
    E07: 224,
    E08: 256,
    E09: 288,
    E10: 320,
    E11: 352,
  },
];

export const FusionHCISoftwareObject: HCISoftware[] = [
  {
    label: FusionHCISoftwareTypes.License_VCPu,
    E03: 96,
    E05: 160,
    E07: 224,
    E09: 288,
    E11: 352,
  },
  {
    label: FusionHCISoftwareTypes.VCP,
    E03: 96 / 2,
    E05: 160 / 2,
    E07: 224 / 2,
    E09: 288 / 2,
    E11: 352 / 2,
  },
  {
    label: FusionHCISoftwareTypes.List_Price,
    E03: 196.8,
    E05: 328.0,
    E07: 459.2,
    E09: 590.4,
    E11: 721.6,
  },
  {
    label: FusionHCISoftwareTypes.Discount,
    E03: 75,
    E05: 75,
    E07: 75,
    E09: 75,
    E11: 75,
  },
];

export const FusionHardwareObject: HCISoftware[] = [
  {
    label: FusionHardwareTypes.Total_Worker_Nodes,
    E03: 3,
    E05: 5,
    E07: 7,
    E09: 9,
    E11: 11,
  },
  {
    label: FusionHardwareTypes.Available_vCPU,
    E03: 120,
    E05: 200,
    E07: 280,
    E09: 360,
    E11: 440,
  },
  {
    label: FusionHardwareTypes.Available_Memory,
    E03: 1296,
    E05: 2160,
    E07: 3024,
    E09: 3888,
    E11: 4752,
  },
  {
    label: FusionHardwareTypes.NVMe_Drives,
    E03: 12,
    E05: 16,
    E07: 20,
    E09: 24,
    E11: 28,
  },
  {
    label: FusionHardwareTypes.Available_NVMe,
    E03: 27,
    E05: 36,
    E07: 45,
    E09: 54,
    E11: 63,
  },
  {
    label: FusionHardwareTypes.List_Price,
    E03: 512.1,
    E05: 634.0,
    E07: 755.0,
    E09: 876.5,
    E11: 998.0,
  },
  {
    label: FusionHardwareTypes.Discount,
    E03: 73,
    E05: 73,
    E07: 73,
    E09: 73,
    E11: 73,
  },
  {
    label: FusionHardwareTypes.Total_in_thousands,
    E03: 143.7,
    E05: 177,
    E07: 210.3,
    E09: 243.6,
    E11: 276.9,
  },
];

export const PremiumSupport: HCISoftware = {
  label: FusionHardwareTypes.Premium_Support,
  E03: 18.8,
  E05: 25.3,
  E07: 31.9,
  E09: 38.4,
  E11: 45.0,
};

export const vCPUSize: Size = {
  X_small: 1,
  Small: 1,
  Medium: 2,
  Large: 4,
  X_large: 8,
};

export const GibMemorySize: Size = {
  X_small: 1,
  Small: 4,
  Medium: 8,
  Large: 24,
  X_large: 48,
};

export enum TCOGraphXAxis {
  Current = 0,
  WithIBM = 1,
}
